module.exports = __webpack_public_path__ + "static/media/sober-eye-target.d32f1233.PNG";